var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-26 -93)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dashboard-2",
    "data-name": "Dashboard",
    transform: "translate(56 135)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.13,
    y: 0
  }, "Dashboard")), /*#__PURE__*/React.createElement("g", {
    id: "download_5_",
    "data-name": "download (5)",
    transform: "translate(42.037 299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23985",
    "data-name": "Path 23985",
    d: "M11.464-205.864a15.2,15.2,0,0,0-5.384,2.233c-1.327.918-1.352.67.223,2.258,1.228,1.253,1.39,1.464,1.39,1.836A1.187,1.187,0,0,1,6.3-198.37a5.725,5.725,0,0,1-1.65-1.377,15.256,15.256,0,0,0-1.377-1.29,9.562,9.562,0,0,0-1.638,2.357,14.672,14.672,0,0,0-1.563,4.938L0-193.221H6.3l.323.385a1.1,1.1,0,0,1-.36,1.787c-.335.149-.955.186-3.337.186H0l.087.583a14.531,14.531,0,0,0,3.077,7.059l.4.422H13.908c8.809,0,10.4-.025,10.607-.174.695-.484,2.134-3,2.7-4.727a20.887,20.887,0,0,0,.695-3.114c0-.025-1.3-.05-2.9-.05A21.22,21.22,0,0,1,21.736-191a1.141,1.141,0,0,1-.62-1.638c.3-.558.385-.571,3.672-.583h3.139l-.062-.409a15.415,15.415,0,0,0-.707-3.04,17.521,17.521,0,0,0-.881-2.01,9.3,9.3,0,0,0-1.638-2.357,12.994,12.994,0,0,0-1.39,1.29,5.97,5.97,0,0,1-1.65,1.377,1.189,1.189,0,0,1-1.377-1.166c0-.372.161-.583,1.39-1.836,1.327-1.34,1.377-1.414,1.141-1.588a15.721,15.721,0,0,0-4.392-2.394A14.475,14.475,0,0,0,15.434-206h-.3v2.978c0,3.375-.05,3.6-.806,3.846a1.04,1.04,0,0,1-.819,0c-.682-.285-.732-.546-.732-3.846V-206l-.335.012C12.245-205.975,11.811-205.926,11.464-205.864Zm4.342,12.779c-.856,1.737-1.588,3.176-1.625,3.213a19.912,19.912,0,0,1-1.675-1.576l-1.625-1.625,3.213-1.613c1.762-.881,3.226-1.6,3.25-1.576S16.674-194.809,15.806-193.085Zm-5.769,3.66a1.139,1.139,0,0,1-.62,1.985,1.176,1.176,0,0,1-1.179-1.675A1.1,1.1,0,0,1,10.037-189.425Zm9.255-.124a1.237,1.237,0,0,1,.447,1.315,1.689,1.689,0,0,1-.471.6,1.127,1.127,0,0,1-1.774-.993A1.164,1.164,0,0,1,19.292-189.549Z",
    fill: "#ffbe66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.fadc2fcdd037e8c0d09c8a6170adc4bc.svg";
export { ForwardRef as ReactComponent };